import type * as React from "react";

export type InfoRow = {
	id: string;
	icon: React.ReactNode;
	primary: React.ReactNode;
	secondary?: React.ReactNode;
};

type Props = {
	rows: InfoRow[];
	/** Wrap the list in a bordered card (detail page) or render bare. */
	boxed?: boolean;
};

export function InfoRows({ rows, boxed = true }: Props) {
	return (
		<div
			className={
				boxed
					? "rounded-[var(--radius-lg)] border border-[var(--border-default)] bg-[var(--surface-default)] px-5"
					: ""
			}
		>
			{rows.map((row, i) => (
				<div
					key={row.id}
					className="flex gap-3 py-3.5"
					style={
						i > 0 ? { borderTop: "1px solid var(--border-subtle)" } : undefined
					}
				>
					<span
						className="mt-0.5 shrink-0 text-[var(--content-muted)]"
						aria-hidden="true"
					>
						{row.icon}
					</span>
					<div className="flex-1 text-[14px] leading-[1.5]">
						<div className="text-[var(--content-primary)]">{row.primary}</div>
						{row.secondary && (
							<div className="mt-0.5 text-[13px] text-[var(--content-muted)]">
								{row.secondary}
							</div>
						)}
					</div>
				</div>
			))}
		</div>
	);
}
